import { getEditLocation } from "../../../core/util/functions";

export const usersLocation = "/listing/users";
export const getUserEditLocation = (id?: string) => getEditLocation(usersLocation, undefined, id);

export const editRouter = getUserEditLocation(":userId?");
